import(/* webpackMode: "eager" */ "/github/workspace/src/app/[locale]/travelers/faqs/page.tsx");
